import React, { Fragment } from "react";
import ContentSection from "./content_section";
import ProviderCarousel from "./provider_carousel";
import TestimonyCarousel from "./testimony_carousel";
import BannerCarousel from "./banner_carousel";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

export default function Home() {
  useDocumentTitle(
    "Pay Bills, Top Up & Accept Payments | YOOZ",
    "Enjoy hassle-free, quick, secure payments with YOOZ. Pay Online in less than 2 minutes or Pay Cash at Agent Locations. Merchants, collect payments Anywhere, Anytime."
  );
  return (
    <Fragment>
      <BannerCarousel />
      <ContentSection />
      <ProviderCarousel />
      <TestimonyCarousel />
    </Fragment>
  );
}
